import { React, useEffect, useState } from "react";
import styles from "../Home.module.css";
import { StockTable } from "../components/StockTable";
import SearchInput from "../components/SearchInput";
import { config } from "../Constants";

const URL = config.url;
export const HomePage = () => {
    const [stocks, setStocks] = useState([]);
    const [keyword, setKeyword] = useState("");

    const filteredStock = Array.isArray(stocks) 
        ? stocks.filter((stock) => stock.name.toLowerCase().includes(keyword))
        : [];

    const onInputChange = (e) => {
        e.preventDefault();
        setKeyword(e.target.value.toLowerCase());
    };

    useEffect(() => {
        const fetchStocks = async () => {
            try{
                const response = await fetch(`${URL}/api/v1/stocks`);
                const apiResponse = await response.json();
                const stocksData = apiResponse.data || [];
                setStocks(stocksData);
            } catch (error) {
                console.error("Error fetching stocks:", error);
                setStocks([]);
            }
        };
        fetchStocks();
        const interval = setInterval(() => fetchStocks(), 5000);
        return () => clearInterval(interval);
    }, []);

    const stockCount = Array.isArray(stocks) ? stocks.length : 0;

    return (
        <div className={styles.container}>
            <div className={styles.inputContainer}>
                <div className={styles.counts}>Fetched {stockCount} items</div>
                <div className={styles.input}>
                    <SearchInput placeholder="Filter by Name" onChange={onInputChange} />
                </div>
            </div>
            <StockTable stock={filteredStock} />
        </div>
    );
};
